var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"templateOne"},[_c('title-widge',{attrs:{"title":_vm.data.title,"subTitle":_vm.data.subTitle,"fontBg":_vm.fontBg}}),_c('div',{staticClass:"divImg"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.data.url),expression:"data.url"}]}),_c('div',{staticClass:"divDesc"},[_vm._v(_vm._s(_vm.data.desc))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }